<div class="title p-2">
    <div class="d-flex justify-content-between align-items-center mt-1">
        <h1 class="m-0">Generează un document</h1>
        <button type="button" class="action-btn d-flex p-0" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>


<div class="row p-2">
    <div class="col">
        <form [formGroup]="form" (ngSubmit)="submitDocumentGenerabil()">
            <div class="row p-1">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Template</mat-label>
                        <mat-select formControlName="template_id" (selectionChange)="onTemplateChange($event.value)">
                            <mat-option *ngFor="let row of templates$ | async" [value]="row.id">
                                {{ row.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Removed Date picker below according to new expectations-->

            <!-- <div class="row p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Valabil</mat-label>
                    <input matInput [matDatepicker]="pickerValabil" formControlName="valability" readonly
                        (focus)="pickerValabil.open()" />
                    <mat-error *ngIf="
                        !form.controls['valability'].valid &&
                        form.controls['valability'].touched
                      ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                    <mat-datepicker #pickerValabil></mat-datepicker>
                </mat-form-field>
            </div> -->

            <!-- <p class="lead choice-text">Alegeți încărcare document sau generează draft</p>

            <div class="doc-type-selection">
                <button type="button" class="btn btn-outline-primary" (click)="toggleUpload()">Incarcă document</button>
                <button type="button" class="btn btn-outline-primary" (click)="toggleDraft()">Generează Draft</button>
            </div> -->
            

            <!-- <div class="row p-1">
                <div class="col">
                    <div *ngIf="showDraft">
                        <div class="fw-bold">Exemplar</div>
                        <angular-editor formControlName="content" [config]="editorConfig"></angular-editor>
                    </div>
                    <div *ngIf="showUpload" class="solicitare-card__upload">
                        <form [formGroup]="fileForm">
                            <div class="solicitare-card__upload-header">
                              <p class="upload-text">Fotografii/Documente</p>
                              <button class="upload-btn" (click)="fileInput.click()" type="button">
                                <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                ÎNCARCĂ
                              </button>
                            </div>
                  
                            <div class="solicitare-card__upload-files" *ngIf="fileForm.get('files')?.value && !uploading">
                              <div class="solicitare-card__upload-file">
                                <span class="solicitare-card__upload-file-name">
                                  {{ (fileForm.get('files')?.value.original_name.length > 30) ?
                                  (fileForm.get('files')?.value.original_name | slice: 0:30) + '..' :
                                  (fileForm.get('files')?.value.original_name) }}
                                </span>
                                <div>
                                  <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat"
                                    (click)="removeFile()">
                                    <img class="btn-img" src="assets/icons/delete.svg" alt="" />
                                  </button>
                                </div>
                              </div>
                            </div>
                  
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading"></mat-spinner>
                  
                            <input type="file" accept="application/pdf"
                              id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event)" style="display: none">
                        </form>
                      </div>
                </div>
            </div> -->
            <ng-container *ngIf="template?.document_generabil_dual">
                <div>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event)" value="toPrimarie">
                        <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
                        <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
                        <mat-button-toggle value="toate">Toate</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <br />
            </ng-container>
            <ng-container *ngIf="template">
                <div class="row">
                    <div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
                        <br />
                        <div class="col">
                            <h2 class="fw-bold">Exemplar Semnatari</h2>
                            <br />
                            <angular-editor class="fit-screen" formControlName="context"
                                [config]="editorConfig"></angular-editor>
                        </div>
                    </div>
                    <div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
                        <br />
                        <div class="col">
                            <h2 class="fw-bold">Exemplar Cetățean</h2>
                            <br />
                            <angular-editor class="fit-screen" formControlName="context_cetatean"
                                [config]="editorConfig"></angular-editor>
                        </div>
                    </div>
                </div>
            </ng-container>

            <br />

            <div class="row mt-2">
                <div class="col">
                    <div class="col d-flex justify-content-end">
                        <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                            {{ helper.dialogConfig.buttonLabels.save }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="section-spinner" *ngIf="isLoading" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);">
        <div class="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>

